import { currentEnvMode, type EnvMode } from '@utils/env.ts'

const modeMap: Record<EnvMode, string> = {
  development: '🏗️',
  integration: '🧩',
  test: '🧪',
  'prod:dev': '🧰',
  production: '',
  live: '✨',
}

function Title() {
  const mode = modeMap[currentEnvMode]
  const title = `${mode ? `${mode} ` : ''}Ubica - Ureka`

  return <title>{title}</title>
}

export default Title